import { render, staticRenderFns } from "./content-group-details.vue?vue&type=template&id=939c206a&scoped=true"
import script from "./content-group-details.vue?vue&type=script&lang=js"
export * from "./content-group-details.vue?vue&type=script&lang=js"
import style0 from "./content-group-details.vue?vue&type=style&index=0&id=939c206a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939c206a",
  null
  
)

export default component.exports